import elMoro from './el-moro.json';
import elRiego from './el-riego.json';
import choRosadoChoRosendo from './cho-rosado-cho-rosendo.json';
import cruzDelAgua from './cruz-del-agua.json';
import elBarranquilloElGarruncho from './el-barranquillo-el-garruncho.json';
import elLlano from './el-llano.json';
import hoyaLosCharcos from './hoya-los-charcos.json';
import laBalona from './la-balona.json';
import laCarretaPasadaLaCarreta from './la-carreta-pasada-la-carreta.json';
import laEscondidaLosEucaliptos from './la-escondida-los-eucaliptos.json';
import laFurnia from './la-furnia.json';
import laQuebradaPieCampeches from './la-quebrada-pie-campeches.json';
import laQuillaCalderon from './la-quilla-calderon.json';
import lasCuchillas from './las-cuchillas.json';
import lasRosas from './las-rosas.json';
import lasVistas from './las-vistas.json';
import lomoLaAvena from './lomo-la-avena.json';
import transversalCuartaLaCorona from './4-transversal-la-corona.json';
import transversalPrimeraLaCoronalaCabezada from './1-transversal-la-corona-la-cabezada.json';
import tresPinos from './tres-pinos.json';
export const routes = new Map([
    elMoro,
    elRiego,
    choRosadoChoRosendo,
    cruzDelAgua,
    elBarranquilloElGarruncho,
    elLlano,
    hoyaLosCharcos,
    laBalona,
    laCarretaPasadaLaCarreta,
    laEscondidaLosEucaliptos,
    laFurnia,
    laQuebradaPieCampeches,
    laQuillaCalderon,
    lasCuchillas,
    lasRosas,
    lasVistas,
    lomoLaAvena,
    transversalCuartaLaCorona,
    transversalPrimeraLaCoronalaCabezada,
    tresPinos,
].map(route => [route.id, route]));
